module.exports = __webpack_public_path__ + "static/media/notes.14cfbbed.png";